import { useChapterStore } from "@/store/linear/chapter";
import { defineStore } from "pinia";
import { instance } from "..";
import { useMaterialStore } from "./material";
import { useTrailStore } from "./trail";

const store = defineStore({
  id: "navigation",
  getters: {
    isNextDisabled: () =>
      useMaterialStore.isLastMaterial &&
      useMaterialStore.materials[useMaterialStore.currentMaterialIndex]?.done &&
      useTrailStore.isLastTrail &&
      !useChapterStore.currentChapter?.done,
  },
  actions: {
    chain(type: "next" | "prev") {
      const actions = {
        next: [
          useMaterialStore.materialNext,
          useTrailStore.trailNext,
          useChapterStore.chapterNext,
        ],
        prev: [
          useMaterialStore.materialPrev,
          useTrailStore.trailPrev,
          useChapterStore.chapterPrev,
        ],
      };

      return actions[type] || [];
    },

    navigate(type: "next" | "prev") {
      for (const action of this.chain(type)) if (action()) return;
    },

    next() {
      this.navigate("next");
    },

    prev() {
      this.navigate("prev");
    },
  },
});

export const useNavigationStore = store(instance);
